"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const isServer_1 = __importDefault(require("../isServer"));
/**
 * Function to prepare the necessary SSR API call
 * Set base url because from server side it has to be a direct call
 * eg. https://dev.lumirental.com/api/branch-service/branch
 */
function prepareSsrCall(store, // TODO: remove unused params after checking all pages
req, platform, passAuthToken) {
    // only runs on server side
    if ((0, isServer_1.default)()) {
        const appEnv = process.env.APP_ENV;
        let baseURL = '';
        // dev/stage/prod server
        if (appEnv !== 'local') {
            // internal api endpoint - read from env var
            const internalAPIEndpoint = process.env
                ? process.env.INTERNAL_ENDPOINT
                : '';
            baseURL = internalAPIEndpoint;
            /**
             * remove /api from endpoint urls.
             * internal endpoint does not use /api
             * eg. http://lumi-api/fleet-service/group?query=&sort=id&order=asc
             */
            http_service_1.default.addEndpointFormatter((endPoint) => {
                console.log('** endpoint: ', endPoint);
                // for strapi cms endpoints
                if (endPoint.includes('web-cms')) {
                    // read the path from the endpoint
                    const splitUrl = endPoint.split('/');
                    const path = splitUrl[splitUrl.length - 1]; // eg. 'home?locale=en'
                    // internal api endpoint - read from env var
                    const internalAPICmsEndpoint = process.env
                        ? process.env.INTERNAL_ENDPOINT_CMS
                        : '';
                    const newUrl = `${internalAPICmsEndpoint}/${path}`;
                    console.log('** endpoint replaced: ', newUrl);
                    return newUrl;
                }
                console.log('** endpoint replaced: ', endPoint.replace(/\/api/, ''));
                return endPoint.replace(/\/api/, '');
            });
        }
        else {
            baseURL = ENDPOINTS_1.default.BASE_URL.local;
        }
        // if (!baseURL) {
        // baseURL = 'https://api-staging.lumirental.com';
        // }
        console.log('baseURL: ', baseURL);
        http_service_1.default.formatBaseUrl(baseURL);
        // add app version & platform header
        const headers = {};
        if (passAuthToken) {
            // read session token
            const token = (0, get_1.default)(req, 'cookies.ltoken', '');
            // bearer token is needed by payment methods api
            headers.Authorization = `Bearer ${token}`;
        }
        else {
            // remove auth headers if any
            http_service_1.default.removeHeaders(['Authorization']);
        }
        http_service_1.default.addHeaders(headers);
    }
}
exports.default = prepareSsrCall;
